function _extends() {
  _extends =
    Object.assign ||
    function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
const DashboardIcon = forwardRef(function(_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    rest = _objectWithoutProperties(_ref, ['color', 'size']);

  return /*#__PURE__*/ React.createElement(
    'svg',
    _extends(
      {
        ref: ref,
        width: size,
        height: size,
        viewBox: '0 0 16 16',
        fill: color,
        xmlns: 'http://www.w3.org/2000/svg',
        stroke: 'none',
      },
      rest
    ),
    /*#__PURE__*/ React.createElement('path', {
      d:
        'M5.6 13.6C5.70454 13.5987 5.80782 13.577 5.904 13.536C6.00095 13.4955 6.09024 13.4387 6.168 13.368C6.2042 13.3286 6.23636 13.2858 6.264 13.24C6.29566 13.1992 6.32002 13.1531 6.336 13.104C6.36464 13.0596 6.38623 13.011 6.4 12.96C6.40393 12.9067 6.40393 12.8533 6.4 12.8C6.39874 12.6955 6.37699 12.5922 6.336 12.496C6.30007 12.3967 6.24275 12.3066 6.16809 12.2319C6.09344 12.1573 6.00328 12.0999 5.904 12.064C5.75918 11.9969 5.59759 11.9746 5.44 12L5.296 12.048C5.24685 12.064 5.20084 12.0883 5.16 12.12C5.11423 12.1476 5.07135 12.1798 5.032 12.216C4.95917 12.2921 4.90208 12.3818 4.864 12.48C4.82091 12.5811 4.79912 12.6901 4.8 12.8C4.8 13.0122 4.88429 13.2157 5.03431 13.3657C5.18434 13.5157 5.38783 13.6 5.6 13.6ZM2.632 13.368C2.70976 13.4387 2.79905 13.4955 2.896 13.536C2.99218 13.577 3.09546 13.5987 3.2 13.6H3.352C3.40499 13.5926 3.45636 13.5764 3.504 13.552C3.55498 13.5345 3.6034 13.5103 3.648 13.48L3.768 13.384C3.83866 13.3062 3.89549 13.2169 3.936 13.12C3.9833 13.0202 4.00528 12.9103 4 12.8C4.00393 12.7467 4.00393 12.6933 4 12.64C3.99124 12.5899 3.97507 12.5413 3.952 12.496C3.93602 12.4469 3.91166 12.4008 3.88 12.36C3.85236 12.3142 3.8202 12.2714 3.784 12.232C3.6715 12.121 3.52864 12.0458 3.37345 12.0159C3.21826 11.986 3.05769 12.0027 2.912 12.064C2.8138 12.1021 2.72408 12.1592 2.648 12.232C2.6118 12.2714 2.57964 12.3142 2.552 12.36C2.52034 12.4008 2.49598 12.4469 2.48 12.496C2.44574 12.5394 2.41872 12.588 2.4 12.64C2.39607 12.6933 2.39607 12.7467 2.4 12.8C2.40126 12.9045 2.42301 13.0078 2.464 13.104C2.50451 13.2009 2.56134 13.2902 2.632 13.368ZM13.6 0H2.4C1.76348 0 1.15303 0.252856 0.702944 0.702944C0.252856 1.15303 0 1.76348 0 2.4V13.6C0 14.2365 0.252856 14.847 0.702944 15.2971C1.15303 15.7471 1.76348 16 2.4 16H13.6C14.2365 16 14.847 15.7471 15.2971 15.2971C15.7471 14.847 16 14.2365 16 13.6V2.4C16 1.76348 15.7471 1.15303 15.2971 0.702944C14.847 0.252856 14.2365 0 13.6 0ZM14.4 13.6C14.4 13.8122 14.3157 14.0157 14.1657 14.1657C14.0157 14.3157 13.8122 14.4 13.6 14.4H2.4C2.18783 14.4 1.98434 14.3157 1.83431 14.1657C1.68429 14.0157 1.6 13.8122 1.6 13.6V11.2H14.4V13.6ZM14.4 9.6H1.6V6.4H4.8C4.90529 6.40061 5.00965 6.38043 5.10713 6.34062C5.2046 6.30081 5.29325 6.24215 5.368 6.168L6.4 5.168L8.64 7.728C8.71226 7.81037 8.80068 7.87701 8.89976 7.9238C8.99884 7.97059 9.10648 7.99653 9.216 8C9.32129 8.00061 9.42566 7.98043 9.52313 7.94062C9.6206 7.9008 9.70925 7.84215 9.784 7.768L11.128 6.4H14.4V9.6ZM14.4 4.8H10.8C10.6947 4.79939 10.5903 4.81957 10.4929 4.85938C10.3954 4.8992 10.3068 4.95785 10.232 5.032L9.24 6.032L7 3.472C6.92517 3.39207 6.83473 3.32835 6.73427 3.28479C6.63382 3.24123 6.52549 3.21876 6.416 3.21876C6.30651 3.21876 6.19818 3.24123 6.09773 3.28479C5.99727 3.32835 5.90683 3.39207 5.832 3.472L4.472 4.8H1.6V2.4C1.6 2.18783 1.68429 1.98434 1.83431 1.83431C1.98434 1.68429 2.18783 1.6 2.4 1.6H13.6C13.8122 1.6 14.0157 1.68429 14.1657 1.83431C14.3157 1.98434 14.4 2.18783 14.4 2.4V4.8Z',
    })
  );
});
DashboardIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
DashboardIcon.displayName = 'DashboardIcon';
export default DashboardIcon;
